module.exports = require('./helpers/bundle-url').getBundleURL('dAHXh') + "logo.c51670a8.svg";